import { Component, Input, ViewChild, AfterViewInit, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { ProgressSpinnerMode } from '@angular/material/progress-spinner';

@Component({
    selector: '',
    template: `
    @if (show) {
      <div [ngClass]="class" class="spinner-container" id="spinner-container">
        @if (percentageValue) {
          <div class="spinner-background">{{ value }} %</div>
        }
        @if (text && text.length !== 0 && !percentageValue) {
          <div class="spinner-background">{{ text }}</div>
        }
        <mat-progress-spinner
          #matLoader
          id="{{ id }}"
          color="{{ color }}"
          mode="{{ mode }}"
          value="{{ value }}"
          strokeWidth="3"
          [diameter]="50"
          >
        </mat-progress-spinner>
      </div>
    }
    `,
    styleUrls: ['./matLoader.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    standalone: false
})
export class MatLoaderComponent implements AfterViewInit {
  private _show = false;
  @Input()
  public get show(): boolean {
    return this._show;
  }
  public set show(value: boolean) {
    this._show = value;
    this.changeDetectorRef.detectChanges();
  }

  @Input() id: string;
  @Input() color: ThemePalette;
  @Input() mode: ProgressSpinnerMode;
  @Input() value: number = 0;
  @Input() percentageValue: boolean;
  @Input() text: string;
  @Input() class: string;
  @ViewChild('matLoader', { static: true }) matLoader;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}
  ngAfterViewInit(): void {}
  addEventListener(
    type: string,
    listener: EventListenerOrEventListenerObject,
    options?: boolean | AddEventListenerOptions
  ) {
    const element: HTMLElement = this.matLoader._elementRef.nativeElement;
    element.addEventListener(type, listener, options);
  }
}
